import gql from 'graphql-tag';

/**
 * 获取模版id配置
 */
export const getSubscribeMessageTemplateIdDocument = gql`
  query getSubscribeMessageTemplateId {
    getSubscribeMessageTemplateId {
      couponGrants
      blindBoxActivityBooking
    }
  }
`;
